export enum Cor {
    AMARELO = 'AMARELO',
    VERDE = 'VERDE',
    VERMELHO = 'VERMELHO'
}
  